import moment from 'moment';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { AppState } from '../models/state/appState';
import AppErrorBoundary from './AppErrorBoundary';
import NewVersionToast from './NewVersionToast';
import Layout from './layout/Layout';
import CallbackPage from './login/CallbackPage';
import LoginPage from './login/LoginPage';
import PrivateRoute from './PrivateRoute';

// initialise locale
const locale = window.navigator.language;
moment.locale(locale);

export default function App() {
  const isSignedIn = useSelector<AppState, boolean>((state) => state.loginDetails.isSignedIn);
  return (
    <AppErrorBoundary>
      <div className="h-100">
        <NewVersionToast />
        <Routes>
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/login/*" element={<LoginPage />} />
          <Route path="/*" element={<PrivateRoute authenticated={isSignedIn} component={Layout} />} />
        </Routes>
      </div>
    </AppErrorBoundary>
  );
}
